import { AxiosError } from "axios";
import { BoardPermissionModel } from "models/BoardPermissionModel";
import { BoardWithPermissionsModel } from "models/BoardWithPermissionsModel";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { createContext } from "react";

export interface BoardContextProps extends BoardPermissionModel {
  boardPermissions: BoardPermissionModel;
  board: BoardWithPermissionsModel | undefined;
  error?: AxiosError;
  isLoading: boolean;
  reloadBoard: () => void;
  confirmDeleteBoard: ConfirmDeleteTarget | undefined;
  setConfirmDeleteBoard: (target: ConfirmDeleteTarget | undefined) => void;
  isBoardDeleting: (id: number) => boolean;
  setBoardDeleting: (id: number, newState: boolean) => void;
  isBoardExpanded: (id: number, defaultValue?: boolean) => boolean;
  toggleBoardExpanded: (id: number) => void;
  setBoardExpanded: (id: number, newState: boolean) => void;
}

export const BoardContext = createContext({} as BoardContextProps);
